import type { RichTextData } from '@stratumn/studio-shared';

export const initialRichTextData: RichTextData = {
  title: 'Default Rich Text Title',
  required: true,
  placeholder: '',
  withMention: false
};
